import React, { useId } from 'react';

export const CARD = 'rounded-2xl bg-white shadow-sm ring-1 ring-gray-200/70 contrast-more:ring-gray-400';

// One block of the Home page: a title, one headline, a sentence and one way on. Home shows at most four.
export default function Block({ title, children, className = '' }: { title: string; children: React.ReactNode; className?: string }) {
  const id = useId();
  return (
    <section aria-labelledby={id} className={`${CARD} min-w-0 p-5 ${className}`}>
      <h2 id={id} className="text-[0.6875rem] font-semibold uppercase tracking-wider text-gray-500">
        {title}
      </h2>
      <div className="mt-2">{children}</div>
    </section>
  );
}

/** The one way on from a block: a link that looks like a quiet button. */
export const LINK_BUTTON =
  'mt-4 inline-flex items-center gap-1 rounded-lg px-3 py-1.5 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-200 transition-colors hover:bg-blue-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 motion-reduce:transition-none';

/** A smaller link inside a row. */
export const ROW_LINK =
  'rounded px-1 py-1 text-xs font-medium text-blue-700 underline-offset-2 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500';
